module.exports = __webpack_public_path__ + "static/media/alumni_society.05b9cee8.jpg";